import { Fragment, useContext, useEffect, useState } from "react";
import { GlobalContext } from "../../../../Context/GlobalContext";
import { isValidArray, showCardDetails, showMyWalletClick } from "../../../../Layout/Common/common";
import Skeleton from "react-loading-skeleton";
import $ from "jquery";
import {
  BANKTRANSFER_TERM,
  MASTERCARD_TERM,
  ONACCOUNT_TERM,
  PAYMENT_RESTRICT_ROLE,
  SHIPPING_METHOD,
  TILL_GPAY_ENABLED,
} from "../../../../constants";
import { MyWalletPayment } from "./myWalletPayment";
import { OnAccountPayment } from "./onAccountPayment";
import { MasterCardPayment } from "./masterCardPayment";
import { NewCardPayment } from "./newcardPayment";
import { PayOnline } from "./payOnline";
import { BankTransfer } from "./bankTransfer";
import { TillGooglePayPayment } from "./tillGooglePayPayment";
import { takePendingPaymentType } from "../../../../Context/hook/tillRedirect";

export const PaymentSection = () => {
  const [paymentMethod, setPaymentMethod] = useState(null);
  const {
    selectedPaymentType,
    setSelectedPaymentType,
    isSubmitOrder,
    setIsSubmitOrder,
    deliveryMethod,
    paymentOption,
    shippingCode,
    storedCard,
    netAmount,
  } = useContext(GlobalContext);

  useEffect(() => {
    if (paymentOption) {
      let payTerm = paymentOption;
      let _paymentOption = [];
      let validStoredCard = storedCard?.filter((card) => card.IsExpired == false);

      if (deliveryMethod == SHIPPING_METHOD[1] && !shippingCode) {
        setPaymentMethod(null);
        setIsSubmitOrder(true);
        setSelectedPaymentType(null);
      } else {
        if (shippingCode && shippingCode.includes("TBA")) {
          _paymentOption = null;
          if (ONACCOUNT_TERM.includes(payTerm.payment_term)) {
            _paymentOption = ["OA", "PAYONLINE"];
          }
          if (MASTERCARD_TERM.includes(payTerm.payment_term)) {
            _paymentOption = ["MC", "PAYONLINE"];
          }
          if (_paymentOption && _paymentOption.includes(selectedPaymentType) == false) {
            setSelectedPaymentType(null);
          }
        } else {
          if (PAYMENT_RESTRICT_ROLE.includes(payTerm.user_role) == false) {
            if (ONACCOUNT_TERM.includes(payTerm.payment_term)) {
              _paymentOption = ["OA", "NEWCARD", "TILLGOOGLEPAY", "MYWALLET"];
            }
            if (MASTERCARD_TERM.includes(payTerm.payment_term)) {
              _paymentOption = ["MC", "NEWCARD", "TILLGOOGLEPAY", "MYWALLET"];
            }
            if (BANKTRANSFER_TERM.includes(payTerm.payment_term)) {
              if (deliveryMethod == SHIPPING_METHOD[2])
                _paymentOption = ["NEWCARD", "TILLGOOGLEPAY", "MYWALLET"];
              else _paymentOption = ["NEWCARD", "TILLGOOGLEPAY", "MYWALLET", "BT"];
            }
          }
        }
        if (isValidArray(_paymentOption)) {
          _paymentOption = _paymentOption.filter((item) => item != "TILLGOOGLEPAY" || TILL_GPAY_ENABLED);
          if (isValidArray(validStoredCard) == false) {
            _paymentOption = _paymentOption.filter((item) => item != "MYWALLET");
          }
          setPaymentMethod(_paymentOption);
          const restoredPaymentType = takePendingPaymentType();
          if (restoredPaymentType && _paymentOption.includes(restoredPaymentType)) {
            handlePaymentSelection(restoredPaymentType);
          } else if (_paymentOption && _paymentOption.includes(selectedPaymentType) == false) {
            handleDefultSelection(_paymentOption, selectedPaymentType);
          }
          setIsSubmitOrder(false);
          //Give it time to render.
        } else {
          setPaymentMethod(null);
          setIsSubmitOrder(true);
          if (shippingCode && shippingCode.includes("TBA")) {
            setSelectedPaymentType(null);
          }
        }
      }
    }
  }, [paymentOption, storedCard, shippingCode, deliveryMethod]);

  const handleDefultSelection = (_paymentOption, _selectedPaymentType) => {
    try {
      if (!_paymentOption || !isValidArray(_paymentOption)) return;
      setTimeout(() => {
        if (_selectedPaymentType) {
          handlePaymentSelection(_selectedPaymentType);
          return;
        }
        if (_paymentOption.includes("OA")) {
          handlePaymentSelection("OA");
        } else if (_paymentOption.includes("MYWALLET")) {
          handlePaymentSelection("MYWALLET");
        } else if (_paymentOption.includes("NEWCARD")) {
          handlePaymentSelection("NEWCARD");
        } else {
          handlePaymentSelection(_paymentOption[0]);
        }
      }, 1000);
    } catch (e) {}
  };

  const paymentComponents = {
    OA: (props) => <OnAccountPayment {...props} />,
    MYWALLET: (props) => <MyWalletPayment {...props} />,
    NEWCARD: (props) => <NewCardPayment {...props} />,
    MC: (props) => <MasterCardPayment {...props} card={paymentOption.card} />,
    PAYONLINE: (props) => <PayOnline {...props} />,
    BT: (props) => <BankTransfer {...props} />,
    TILLGOOGLEPAY: (props) => <TillGooglePayPayment {...props} />,
  };

  const handlePaymentSelection = (e) => {
    if (e == "OA") {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").show("slow");
    } else if (e == "NEWCARD") {
      $(".card-details-list1").show("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
    } else if (e == "TILLGOOGLEPAY") {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").show("slow");
      $(".acc-details-list1").hide("slow");
    } else {
      $(".card-details-list1").hide("slow");
      $(".tillgpay-details-list").hide("slow");
      $(".acc-details-list1").hide("slow");
    }
    setSelectedPaymentType(e);
  };

  return (
    <Fragment>
      {paymentMethod && (
        <div className="selected-shipping-method">
          <h3>Payment</h3>
          <div className="shipping-method-list">
            <div className="shipPayment-listing" id="accordionExample">
              {paymentMethod.map((type, index) =>
                paymentComponents[type]
                  ? paymentComponents[type]({
                      handleOnCheck: handlePaymentSelection,
                      defaultCheck: selectedPaymentType == type,
                    })
                  : null,
              )}
            </div>
          </div>
        </div>
      )}
      <div className="total-amount-checkout">
        <p>Total </p>
        {shippingCode == "TBA" ? <p> TBA</p> : <p>${netAmount || <Skeleton width="50" />}</p>}
      </div>
    </Fragment>
  );
};
